import React from "react"
import Link from "gatsby-link"

import Guide from "../components/guide"
import Examples from "../components/Examples"

const IndexPage = () => (
  <div className="container">
    <Guide />
    <Examples />
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js